import { useParams, useNavigate } from "react-router-dom";
import CollectFeeDialog from "./CollectFeeDialog";

export default function CollectFees() {
  const { studentId } = useParams();
  const nav = useNavigate();
  return (
    <CollectFeeDialog
      open
      studentId={studentId || null}
      onOpenChange={(o) => { if (!o) nav(-1); }}
      onCollected={() => {}}
    />
  );
}
